import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { changePassword } from "@/lib/apiData";
import { useAuth } from "@/context/AuthContext";

const ROLE_LABELS = { super_admin: "Super Admin", manager: "Manager", editor: "Content Editor", support: "Support" };
const fieldCls = "mt-1 h-11 bg-[#fbf9f7] border-neutral-300 rounded-none focus-visible:ring-[#d00000]";

export default function MyAccount() {
  const { user } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error("New passwords don't match");
    setBusy(true);
    try {
      await changePassword({ current_password: f.current_password, new_password: f.new_password });
      toast.success("Password changed");
      setF({ current_password: "", new_password: "", confirm: "" });
    } catch (x) {
      toast.error(x.response?.data?.detail || "Could not change password");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="my-account-panel" className="max-w-xl">
      <h2 className="font-display text-3xl font-black text-neutral-900">My account</h2>
      <div className="bg-white border border-neutral-200 p-6 mt-6">
        <p className="font-medium text-neutral-900">{user?.name}</p>
        <p className="text-sm text-neutral-500">{user?.email}</p>
        <span className="inline-block mt-3 text-xs px-2 py-1 bg-[#d00000]/10 text-[#d00000]" data-testid="my-role">{ROLE_LABELS[user?.role] || user?.role}</span>
      </div>
      <form onSubmit={submit} className="bg-white border border-neutral-200 p-6 mt-6 space-y-4">
        <h3 className="font-display text-xl font-bold text-neutral-900">Change password</h3>
        <Input required type="password" placeholder="Current password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="current-password" className={fieldCls} />
        <Input required type="password" autoComplete="new-password" placeholder="New password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} data-testid="new-password" className={fieldCls} />
        <Input required type="password" autoComplete="new-password" placeholder="Repeat new password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="confirm-password" className={fieldCls} />
        <Button type="submit" disabled={busy} data-testid="change-password-btn" className="bg-[#d00000] hover:bg-[#a30000] text-white rounded-none">Change password</Button>
      </form>
    </div>
  );
}
